import React, { useState, CSSProperties, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

export type UseHighlight = (options?: {
  containerId?: string;
}) => {
  turnOn: () => void;
  turnOff: () => void;
  targetStyle: CSSProperties;
  Portal: ReturnType<typeof createPortal> | null;
};

export const useHighlight: UseHighlight = opts => {
  const newOpts = {
    ...opts,
    containerId: "overlay-container"
  };

  const [on, setOn] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const turnOn = () => {
    setOn(true);
  };

  const turnOff = () => {
    setOn(false);
  };

  useEffect(() => {
    containerRef.current = document.querySelector(
      newOpts.containerId[0] === "#"
        ? newOpts.containerId
        : `#${newOpts.containerId}`
    );
  }, []);

  return {
    turnOn,
    turnOff,
    targetStyle: on
      ? {
          zIndex: 10001,
          position: "relative"
        }
      : {},
    Portal:
      on && containerRef.current
        ? createPortal(
            <div
              style={{ zIndex: 10000 }}
              className="fixed w-screen h-full top-0 left-0 bg-black bg-opacity-50"
            />,
            containerRef.current
          )
        : null
  };
};
